import React, { useState } from 'react';
import Imagez from '../../../../../lib/reusable/Imagez';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import ManageProduct from '../../../../../components/ManageProduct';
import ReactModal from '../../../../../components/ReactModal';


const TreeProductElement = (props) => {
  const { product, fromCategoryId } = props;
  const [errorImage, setErrorImage] = useState(false);
  const [productModalIsOpen, seProductModalIsOpen] = useState(false);

  const handleNoImage = () => {
    setErrorImage(true);
  };
  const hasImage = product.image && !errorImage;

  const handleProductClick = () => {
    seProductModalIsOpen(true);
  };

  const square = '30px';

  const isExtraCategoryProduct = fromCategoryId !== product.category_id;

  const smallWindow = window.innerWidth < 500;

  return (
    <div style={{ marginLeft: '0px', marginRight: '0px'}}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          opacity: product.active ? 1 : 0.3,
          fontSize: '0.8rem',
          padding: '6px 3px',
          borderRadius: '3px',
          marginLeft: smallWindow ? '-22px' : 'auto',
        }}
        onClick={handleProductClick}
      >
        {!isExtraCategoryProduct ? (
          <div
            style={{
              fontWeight: 'normal',
              letterSpacing: '-0.024em',
              marginRight: '10px',
              fontSize: '0.64rem',
              minWidth: '16px',
            }}
          >
            {product.position}
          </div>
        ) : (
          <DoubleArrowIcon
            className="s-24-i txt-info"
            style={{ margin: '0 10px 0 -15px' }}
          />
        )}
        {hasImage ? (
          <div style={{ width: square, borderRadius: '4px' }}>
            <Imagez
              br="4px"
              image={product.image}
              height={square}
              handleNoImage={handleNoImage}
              loaderWidth={20}
            />
          </div>
        ) : (
          <div style={{ width: square, height: square, background: '#ccc', borderRadius: '4px' }} />
        )}
        <div style={{ letterSpacing: '-0.024em', marginLeft: '10px' }}>{product.name}</div>
        <div style={{ fontWeight: 'bold', letterSpacing: '-0.024em', marginLeft: '5px', textAlign: 'right' }}>
          {`${product.cost} ${product.currency}`}
        </div>
      </div>
      {productModalIsOpen && (
        <ReactModal
          modalIsOpen={productModalIsOpen}
          setIsOpen={seProductModalIsOpen}
        >
          <ManageProduct
            productId={product.id}
            categoryId={product.category_id}
            close={() => seProductModalIsOpen(false)}
          />
          <div style={{ height: '200px' }} />
        </ReactModal>
      )}
    </div>
  );
};

export default TreeProductElement;
